import { fetch as apiFetch } from '../fetchWrapper/fetch';
import { MARKETPLACE_API_URL } from '../constants';

export type AuthStatus = 'pending_auth' | 'authenticated' | null;

export interface AuthStatusResponse {
  type: 'auth_status';
  data: {
    authenticated: boolean;
    status: AuthStatus;
    expiresAt?: number;
  };
}

export const getAuthStatus = async (addonId: string): Promise<AuthStatusResponse> => {
  const response = await apiFetch(`${MARKETPLACE_API_URL}/addons/${addonId}/auth/status`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
};
